import axios from 'axios'

axios.defaults.baseURL = 'https://chainstats-a50c0e819dd5.herokuapp.com/api'